import React from 'react';
import AudioPlayer from './AudioPlayer';

interface FAQAudioBlockProps {
  title: string;
  audioSrc: string;
  subtitle?: string;
  ctaLabel?: string;
  brandColor?: string;
  durationHintSec?: number;
  audioId?: string;
}

export default function FAQAudioBlock({
  title,
  audioSrc,
  subtitle,
  ctaLabel = "🎧 Écouter le résumé",
  brandColor = "hsl(85, 40%, 50%)",
  durationHintSec = 240,
  audioId
}: FAQAudioBlockProps) {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Elegant background with subtle gradients */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/8 via-background to-primary/4" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,hsl(var(--primary)/0.1),transparent_70%)]" />
      
      <div className="container mx-auto px-6 relative">
        <div className="max-w-5xl mx-auto">
          {/* Enhanced card design */}
          <div className="bg-card/80 backdrop-blur-sm border border-border/50 rounded-3xl p-12 shadow-2xl hover:shadow-3xl transition-all duration-500">
            {/* Subtle decorative elements */}
            <div className="absolute top-6 left-6 w-12 h-12 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 blur-xl" />
            <div className="absolute bottom-6 right-6 w-16 h-16 rounded-full bg-gradient-to-tl from-primary/15 to-primary/3 blur-2xl" />
            
            <div className="relative text-center">
              <AudioPlayer
                title={title}
                src={audioSrc}
                ctaLabel={ctaLabel}
                brandColor={brandColor}
                durationHintSec={durationHintSec}
                subtitle={subtitle}
                className="relative z-10"
                id={audioId}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}